import React, { useMemo } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevelMultiplier } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const LightningLinkMultiplierPlayerLevel: React.FC<IPlayerLevel> = ({
  assetUrl,
  text = [],
}) => {
  const leftText = useMemo(
    () =>
      Array.isArray(text) ? text.find(({ id }) => id === 'left')?.content : '',
    [text],
  );

  const leftValue = useMemo(
    () =>
      Array.isArray(text)
        ? text.find(({ id }) => id === 'left_value')?.content
        : '',
    [text],
  );

  const bottomText = useMemo(
    () =>
      Array.isArray(text)
        ? text.find(({ id }) => id === 'bottom')?.content
        : '',
    [text],
  );

  return (
    <StyledPlayerLevelMultiplier className={'player-level multiplier'}>
      <img className={'image'} src={assetUrl} alt={'value player level'} />
      <div className="left-container">
        {leftText && <div className="left-text">{leftText}</div>}
        {leftValue && (
          <AutoTextSize
            maxFontSizePx={32}
            minFontSizePx={8}
            mode="oneline"
            className="left-value"
          >
            {leftValue}
          </AutoTextSize>
        )}
      </div>
      {bottomText && (
        <div className="bottom-text-container">
          <AutoTextSize
            maxFontSizePx={9}
            minFontSizePx={2}
            mode="oneline"
            className="bottom-text"
          >
            {bottomText}
          </AutoTextSize>
        </div>
      )}
    </StyledPlayerLevelMultiplier>
  );
};
